module.exports = {"validation":{"required":"To pole jest wymagane","email":"Nieprawidłowy adres e-mail"}}